(function () {
  'use strict';

  angular.module('app').component('invoiceRelatedTransactions', invoiceRelatedTransactions());

  function invoiceRelatedTransactions() {
    return {
      bindings: {
        invoice: '<',
        clientId: '<',
      },
      controller: InvoiceRelatedTransactionsComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/invoices/components/invoice-related-transactions/' +
        'invoice-related-transactions.component.html',
    };
  }

  InvoiceRelatedTransactionsComponent.$inject = ['InvoiceService', 'RelatedTransactionService'];

  function InvoiceRelatedTransactionsComponent(InvoiceService, RelatedTransactionService) {
    const vm = this;

    vm.$onInit = function () {
      getRelatedTransactions();
    };

    vm.selectTransaction = function (transaction, index) {
      vm.transactionSelected = transaction;
      transaction.show = !transaction.show;

      if (index !== undefined) {
        vm.indexSelected = index;
      }
    };

    vm.openRelatedTransactionModal = function (transaction) {
      RelatedTransactionService.openRelatedTransactionModal(transaction);
    };

    function getRelatedTransactions() {
      vm.loadingRelatedTransactions = true;
      InvoiceService.getRelatedTransactions(vm.invoice.id, vm.clientId).then(function (data) {
        vm.bookings = data.bookings;
        vm.invoice = data.invoice.invoice;

        if (vm.bookings.length > 0) {
          vm.bookings.forEach((booking) => {
            booking.invoice = angular.copy(vm.invoice);
          });
        }

        if (vm.invoice) {
          vm.creditNotes = data.invoice.data.creditNotes || [];
          vm.debitNotes = data.invoice.data.debitNotes || [];
          vm.receivedPayments = data.invoice.data.receivedPayments || [];
        }

        vm.loadingRelatedTransactions = false;
      });
    }
  }
})();
